import { EngagementMeetingParticipant } from '../../../../slices/marketplace/meetings/models/engagement-meeting-participant';
import { MeetingParticipantSource } from '../../../../slices/marketplace/meetings/models/enums/meeting-participant-source.enum';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';

export function canDeleteParticipant(
    participant: EngagementMeetingParticipant,
    allParticipants: EngagementMeetingParticipant[],
    party: TimelineParty,
    canManageGlobalParticipants: boolean,
    currentUserId: number | undefined,
): boolean {
    if (allParticipants.length <= 1) return false;
    if (allParticipants.filter(p => p.party === participant.party).length <= 1) return false;
    if (party !== TimelineParty.Buyer && party !== TimelineParty.Seller) return false;
    if (participant.source === MeetingParticipantSource.TeamMember && participant.userId != null) {
        if (participant.userId === currentUserId) return true;
        if (canManageGlobalParticipants && party === TimelineParty.Buyer && participant.party === TimelineParty.Buyer) return true;
        if (party === TimelineParty.Seller && participant.party === TimelineParty.Seller) return true;
        return false;
    }
    return canManageGlobalParticipants && participant.party === party;
}

export function deriveIsSelfAbsent(
    participants: EngagementMeetingParticipant[],
    currentUserId: number | undefined,
): boolean {
    if (currentUserId == null) return false;
    return !participants.some(
        (p) => p.source === MeetingParticipantSource.TeamMember && p.userId === currentUserId,
    );
}
